import './index.scss';

import React from 'react';

const CINBox = ({ cins, total_quantity }) => {
  return (
    <div className="transaction_box w-100 pt-3 mb-4">
      <div className="transaction_box_section w-100 mb-5">
        {cins.map((cin) => {
          return (
            <div key={cin.cin} className="transaction_box_cylinder d-flex justify-content-between">
              <div>{cin.cin}</div>
              <div>{cin.gas_quantity} Kg</div>
            </div>
          );
        })}
      </div>

      <div className="transaction_box_cylinder d-flex justify-content-between">
        <div>Total Gas Quantity Purchased</div>
        <div>{total_quantity} Kg</div>
      </div>
    </div>
  );
};

export default CINBox;
